// PwappyPointSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pwappyPoints: 0,
};

const pwappyPointSlice = createSlice({
  name: 'pwappyPoint',
  initialState,
  reducers: {
    setPwappyPoints(state, action) {
      state.pwappyPoints = action.payload;
    },
  },
});

export const { setPwappyPoints } = pwappyPointSlice.actions;
export default pwappyPointSlice.reducer; 